import React, {useMemo} from "react";
import {useAppSession} from "../../../../layout/core/AppSession";
import {toAbsoluteUrl} from "../../../../_helpers";
import SVG from "react-inlinesvg";

const ModuleLogo = () => {
    const appModule = useAppSession();

    const moduleConfig = useMemo(() => {
        return appModule.currentModuleConfig;
    }, [appModule]);

    return (
        <div className={`topbar-item`}>
            <div id="od_modules_dropdown_toggle" style={{height : 'calc(1.0em + 1.65rem + 2px)', backgroundColor : '#ffffff26'}}
                 className="btn btn-icon btn-icon-mobile w-auto btn-topbar d-flex align-items-center btn-lg px-3 waves-effect waves-light">
                {moduleConfig.logo && <img className="mr-1" src={toAbsoluteUrl(moduleConfig.logo)} alt=""/>}
                <span className="text-white">{moduleConfig.module_name.toUpperCase()}</span>
                <span className="svg-icon svg-icon-white ml-2">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}/>
                </span>
            </div>
        </div>
    );
}

export default ModuleLogo;
